<template>
  <div>
    <v-card-actions>
      <v-card-title>PLATFORMS</v-card-title>
      <v-btn fab small color="primary" @click="platformAdd = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
    <project-platform-view></project-platform-view>
    <project-platform-add
      :platformAdd="platformAdd"
      :platformList="platformList"
      :selectedList="platforms"
      @add-platform-model-update="updatePlatformAdd"
    ></project-platform-add>
  </div>
</template>
<script>
import ProjectPlatformAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectPlatformAdd";
import ProjectPlatformView from "@/components/Projects/ProjectInnerCardsComp/ProjectPlatformView";
export default {
  name: "ProjectPlatform",
  props: ["platforms", "platformList"],
  components: {
    "project-platform-view": ProjectPlatformView,
    "project-platform-add": ProjectPlatformAdd,
  },
  data() {
    return {
      platformAdd: false,
    };
  },
  methods: {
    updatePlatformAdd(value) {
      this.platformAdd = value;
    },
  },
};
</script>
